import React from 'react';
import { CTAButton } from './CTAButton';
import { ShieldCheckIcon, DownloadIcon, PrinterIcon } from 'lucide-react';
export function ClosingSection() {
  return <section id="precio" className="w-full bg-[#1B2A4A] text-white" aria-label="Cierre y compra" data-id="element-9">
      <div className="max-w-3xl mx-auto px-5 py-16 md:py-24" data-id="element-10">
        {/* Price Reveal */}
        <div className="text-center mb-12" data-id="element-11">
          <p className="text-white/60 text-lg mb-2" data-id="element-12">Precio único:</p>
          <div className="flex items-center justify-center gap-2 mb-3" data-id="element-13">
            <span className="text-5xl md:text-7xl font-bold text-white" data-id="element-14">
              $6.39
            </span>
          </div>
          <p className="text-white/70 text-lg" data-id="element-15">
            Lo que cuesta una comida afuera…
            <br data-id="element-16" />
            <span className="text-white/50 italic" data-id="element-17">
              pero esta noche no estás pensando en comida.
            </span>
          </p>
        </div>

        {/* Features pills */}
        <div className="flex flex-wrap justify-center gap-3 mb-12" data-id="element-18">
          <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2" data-id="element-19">
            <DownloadIcon className="w-4 h-4 text-[#10B981]" aria-hidden="true" data-id="element-20" />
            <span className="text-sm text-white/90" data-id="element-21">Descarga inmediata</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2" data-id="element-22">
            <PrinterIcon className="w-4 h-4 text-[#10B981]" aria-hidden="true" data-id="element-23" />
            <span className="text-sm text-white/90" data-id="element-24">PDF imprimible</span>
          </div>
          <div className="flex items-center gap-2 bg-white/10 rounded-full px-4 py-2" data-id="element-25">
            <ShieldCheckIcon className="w-4 h-4 text-[#10B981]" aria-hidden="true" data-id="element-26" />
            <span className="text-sm text-white/90" data-id="element-27">Pago seguro</span>
          </div>
        </div>

        {/* Emotional Close */}
        <div className="max-w-xl mx-auto text-center space-y-6 mb-12" data-id="element-28">
          <p className="text-xl md:text-2xl leading-relaxed text-white/90" data-id="element-29">
            Si hoy estás en esa cama, con la mano en la cara, pensando{' '}
            <em className="text-[#F59E0B]" data-id="element-30">"ya no puedo"</em>…
          </p>
          <p className="text-xl md:text-2xl font-bold text-white" data-id="element-31">
            No necesitas más videos.
            <br data-id="element-32" />
            Necesitas un plan.
          </p>
        </div>

        {/* Final CTA */}
        <CTAButton text="Quiero Mi Protocolo — $6.39" subtitle="Descárgalo, imprímelo si puedes, y úsalo hoy." dark data-id="element-33" />

        {/* Disclaimer */}
        <div className="mt-16 pt-8 border-t border-white/10" data-id="element-34">
          <p className="text-white/40 text-xs text-center leading-relaxed max-w-lg mx-auto" data-id="element-35">
            Aviso: Esta guía es un recurso educativo e informativo. No sustituye
            el diagnóstico, consejo ni tratamiento de un profesional de salud
            dental. Si tienes una emergencia médica, llama al 911 o ve a la sala
            de emergencias más cercana.
          </p>
        </div>
      </div>
    </section>;
}